// Lander template constants
export const LanderTemplate = {
  SIMPLE_2C: "SIMPLE_2C",
  SIMPLE_2C_LIGHT: "SIMPLE_2C_LIGHT",
  SIMPLE_2C_EXPERIMENT: "SIMPLE_2C_EXPERIMENT",
  LIGHT_BLUE: "LIGHT_BLUE",
  VERTICAL_LINES: "VERTICAL_LINES",
  ARROW_1: "ARROW_1",
  ARROW_2: "ARROW_2",
  ARROW_3: "ARROW_3",
  ARROW_LIST: ["ARROW_1", "ARROW_3", "ARROW_2"],
  PARK_WEB: "PARK_WEB",
  PARK_WEB_HEG: "PARK_WEB_HEG",
  DEFAULT: "SIMPLE_2C",
} as const;
